import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import apiClient from '../../utils/api';

function ForgotPassword() {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await apiClient.requestPasswordReset(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || t('auth.forgotPassword.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <img
          src="https://customer-assets.emergentagent.com/job_f48ed865-f137-40ec-8ec5-750617ca0014/artifacts/jm5y5oub_logo.png"
          alt="ZENTA Logo"
          className="auth-logo"
        />
        <h1 className="auth-title">ZENTA</h1>
        <p className="auth-subtitle">{t('auth.forgotPassword.title')}</p>

        {success ? (
          <div className="success-message" data-testid="success-message">
            <p>
              <strong>{i18n.language === 'de' ? 'Email gesendet!' : 'Email sent!'}</strong>
            </p>
            <p>
              {t('auth.forgotPassword.success')}
            </p>
            <p className="text-small" style={{ marginTop: '1rem' }}>
              {i18n.language === 'de' 
                ? 'Bitte überprüfen Sie auch Ihren Spam-Ordner.' 
                : 'Please also check your spam folder.'}
            </p>
          </div>
        ) : (
          <>
            <p className="auth-description">
              {t('auth.forgotPassword.subtitle')}
            </p>

            {error && (
              <div className="error-message" data-testid="error-message">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">{t('auth.forgotPassword.email')}</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="email-input"
                  placeholder={t('auth.forgotPassword.emailPlaceholder')}
                />
              </div>

              <button
                type="submit"
                className="btn-primary"
                disabled={loading}
                data-testid="submit-button"
              >
                {loading ? t('common.loading') : t('auth.forgotPassword.submit')}
              </button>
            </form>
          </>
        )}

        <div className="auth-link">
          <Link to="/login" data-testid="back-to-login-link">
            {t('auth.forgotPassword.backToLogin')}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
